'use client';

import {
  getPreviousPath,
  removeLastPath,
  useAsPath,
} from '@/features/back-button/store/path-store';
import { getPathname, usePathname } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import { IconArrowNarrowLeft, IconChevronLeft } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

type BackButtonProps = {
  children?: React.ReactNode;
  className?: string;
  baseBackPath?: string;
};

export const BackButton = ({
  children,
  className,
  baseBackPath,
}: BackButtonProps) => {
  const router = useRouter();
  const state = useAsPath();
  const visitedPaths = state.visitedPaths;
  const t = useTranslations('common');
  const pathname = usePathname();
  const handleBack = () => {
    const previousPath = getPreviousPath();

    if (previousPath) {
      removeLastPath();
      const localizedPathname: string = getPathname({
        href: previousPath,
        locale: 'pl',
      });

      if (pathname === '/cart/[id]') {
        router.push('/diets');
      } else if (pathname === '/cart') {
        router.push(previousPath);
      } else {
        router.back();
      }
    } else if (baseBackPath) {
      router.push(baseBackPath);
    }
  };

  return (
    <div className={cn('flex max-md:items-center md:flex-col', className)}>
      {(visitedPaths.length > 0 || baseBackPath) && (
        <button
          onClick={handleBack}
          className='group flex items-center gap-2 font-medium text-white transition-colors hover:underline max-md:pr-2 md:mb-3'
        >
          <IconArrowNarrowLeft
            stroke={1.25}
            className='relative left-0 hidden  transition-all duration-500 group-hover:-left-1 md:block'
          />
          <IconChevronLeft stroke={1.25} className='-ml-2 block md:hidden' />
          <span className='hidden md:block'>{t('back')}</span>
        </button>
      )}
      {children}
    </div>
  );
};
